export const boardHeadText: string[] = ['번호', '제목', '작성자', '등록일'];
